export enum ActiveCampaignEvents {
  ENTERED_FLOW = 'EnteredFlow',
  ADD_CONTACT_INFO = 'AddContactInfo',
  VERIFIED_EMAIL = 'VerifiedEmail',
  ENTERED_MINGA_DETAILS = 'EnteredMingaDetails',
  MINGA_CREATED = 'MingaCreated',
}
